
export default (width = 24, height = 24, color = '#797979') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <path d="M0 15.632h11.594v-1.7H0zm0 5.96h9.275v-1.7H0zM0 9.827h15.072v-1.7H0zm22.023-7.505L0 2.368l.004 1.654 22.025-.046zM19 17.093h1.8V8.966H19zm-2.768 0l3.48 4.644 3.476-4.644z" fill="${color}" fill-rule="evenodd"/>
</svg>
`